import React from 'react';

/**
 * MultiSelectChips — labelled wrap of pill-shaped, individually toggleable chips.
 * Used by the Reports Filter step for all five filter dimensions.
 */
const MultiSelectChips = ({ label, required = false, options, selected, onToggle }) => {
  const selectedSet = new Set(selected);
  const labelId = `chips-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className="reports-field">
      <div className="reports-field-label" id={labelId}>
        {label}
        {required && <span className="reports-field-required" aria-hidden="true">*</span>}
      </div>
      <div className="reports-chip-wrap" role="group" aria-labelledby={labelId}>
        {options.map((value) => {
          const isSel = selectedSet.has(value);
          return (
            <button
              type="button"
              key={value}
              className={`reports-pill${isSel ? ' reports-pill--selected' : ''}`}
              aria-pressed={isSel}
              onClick={() => onToggle(value)}
            >
              {value}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MultiSelectChips;
